/** @fileoverview Helper functions for the user groups of an app and the actions a viewer may run. */

import type { FabrikAction, FabrikUserGroup } from '../../types/apps';

/**
 * Lists the ids of the groups that hold the email, compared without case. Used in the builder
 * only: groups sent to a hosted app carry no emails, so there the server's list is used.
 * @param userGroups user groups of the definition
 * @param email email of the signed in viewer
 */
export const readViewerGroups = (
  userGroups: FabrikUserGroup[] | undefined,
  email: string | null | undefined
): string[] => {
  const viewerEmail = email?.trim().toLowerCase();
  if (!viewerEmail) {
    return [];
  }
  return (userGroups ?? [])
    .filter(({ emails }) =>
      (emails ?? []).some((groupEmail) => groupEmail.toLowerCase() === viewerEmail)
    )
    .map(({ id }) => id);
};

/**
 * Lists the ids of the actions the viewer may not run; an action without allowedGroups is open
 * to everyone.
 * @param actions actions of the definition
 * @param viewerGroups ids of the groups the viewer is in
 */
export const readBlockedActionIds = (
  actions: FabrikAction[],
  viewerGroups: string[]
): ReadonlySet<string> =>
  new Set(
    actions
      .filter(
        ({ allowedGroups }) =>
          allowedGroups?.length && !allowedGroups.some((groupId) => viewerGroups.includes(groupId))
      )
      .map(({ id }) => id)
  );
